/** @jsx tsx */
import { tsx } from "@dojo/framework/core/vdom";
import { WidgetBase } from "@dojo/framework/core/WidgetBase";
import { ANGLE_ZERO, MAX_Z_INDEX } from "../../Constants";

/**
 * Selection drag box properties
 */
export interface IDragBoxProperties {
    x: number;
    y: number;
    width: number;
    height: number;
    flipH: boolean;
    rot: number;
}

/**
 * On Drag selection box render props interface
 */
export interface IDragSelectionBoxProps {
    boxProps: IDragBoxProperties;
}

/**
 * Drag selection box widget
 */
export class DragSelectionBox extends WidgetBase<IDragSelectionBoxProps> {
	/**
     * Override WidgetBase#render to produce a virtual DOM tree.
     * @returns {HNode} Each time render() executes, it should build the entire virtual DOM tree.
     */
	protected render() {
		const { x, y, width, height, rot, flipH } = this.properties.boxProps;
		let scale = "";

		if (flipH) {
			scale = "scale(-1, 1)";
		}
		const newRot = rot || ANGLE_ZERO;
		// hide-in-thumbnail class is used to hide the selection overlay in thumbnail by host application
		return (
			<div
				classes="c8-canvas-hide-in-thumbnail"
				styles={{
					border: "2px solid #0784B6",
					height: `${height}px`,
					left: `${x}px`,
					position: "absolute",
					top: `${y}px`,
					transform: `rotate(${newRot}deg) ${scale}`,
					transformOrigin: "center",
					width: `${width}px`,
					zIndex: `${MAX_Z_INDEX}`,
				}}
			>
				<div
					styles={{
						background: "#0784B6",
						height: "100%",
						opacity: "0.2",
						width: "100%",
					}}
				/>
			</div>
		);
	}
}

export default DragSelectionBox;
